import React, { ReactElement } from 'react';
import { Form, Select } from 'antd';

import { Breed } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled: boolean;
}

function FilterFieldBreeds(props: Props): ReactElement {
  const { disabled } = props;
  const breeds: Breed[] = pricingContent?.breeds || [];
  breeds.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Form.Item name="breed_id" style={{ width: 200, marginBottom: 0 }}>
      <Select
        data-testid={testId.filterFieldBreeds}
        placeholder="Breed"
        showSearch
        allowClear
        disabled={disabled}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {breeds.map((breed: Breed) => (
          <Select.Option
            data-testid={testId.filterFieldBreedOption}
            key={breed.id}
            value={breed.id}
          >
            {breed.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default FilterFieldBreeds;
